/**
 * @file Confirmation
 * @author Wence
 */

import React, {PureComponent} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './index.less';

export class Body extends PureComponent {
    static propTypes = {
        onClose: PropTypes.func,
        disableCloseByMask: PropTypes.bool,
        content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
        okText: PropTypes.string,
        concelText: PropTypes.string,
        className: PropTypes.string,
        onCancel: PropTypes.func,
        onOk: PropTypes.func,
        renderFooter: PropTypes.func,
        renderBody: PropTypes.func,
        isAnimation: PropTypes.bool
    }

    static defaultProps = {
        isAnimation: true
    }

    constructor(props) {
        super(props);

        this.state = {
            isAnimation: false
        };

        this.clearTimer = this.clearTimer.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onCancel = this.onCancel.bind(this);
    }

    clearTimer() {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    }

    componentDidMount() {
        this.clearTimer();

        if (this.props.isAnimation) {
            this.timer = setTimeout(() => {
                this.setState({isAnimation: true});
            }, 50);
        }
        else {
            this.setState({isAnimation: true});
        }
    }

    componentWillUnmount() {
        this.clearTimer();
    }

    onClose() {
        const onClose = this.props.onClose;
        this.setState({isAnimation: false});
        if (this.props.isAnimation) {
            setTimeout(() => {
                onClose && onClose();
            }, 50);
        }
        else {
            onClose && onClose();
        }
    }

    onCancel() {
        const onCancel = this.props.onCancel;

        onCancel && onCancel();

        this.onClose();
    }

    render() {
        const {content, okText, concelText, onOk, renderFooter, className, renderBody, disableCloseByMask} = this.props;
        const isAnimation = this.state.isAnimation;

        return (
            <div className={classnames('xb-comfirm', className)}>
                <div className={classnames('xb-comfirm-mask', {active: isAnimation})}></div>
                <div className="xb-comfirm-wrap">
                    <div onClick={disableCloseByMask ? () => null : this.onClose} className="xb-comfirm-blank"></div>
                    <div className={classnames('xb-comfirm-content', {active: isAnimation})}>
                        {typeof renderBody === 'function'
                            ? renderBody()
                            : <div className="xb-comfirm-body">
                                {content}
                            </div>}
                        {typeof renderFooter === 'function'
                            ? renderFooter()
                            : <div className="xb-comfirm-footer">
                                <div
                                    onClick={this.onCancel}
                                    className="xb-comfirm-btn xb-comfirm-cancel">
                                    {concelText || '取消'}
                                </div>
                                <div
                                    onClick={onOk}
                                    className="xb-comfirm-btn xb-comfirm-ok">
                                    {okText || '联系'}
                                </div>
                            </div>}
                    </div>
                </div>
            </div>
        );
    }
}

export default function confirmation(props = {}) {
    const container = document.createElement('div');
    const body = document.body || document.documentElement.body;
    let close = () => {
        ReactDOM.unmountComponentAtNode(container);
        if (container && container.parentNode) {
            container.parentNode.removeChild(container);
        }
        if (close) {
            close = null;
        }
    };

    body.appendChild(container);
    ReactDOM.render(<Body onClose={close} {...props} />, container);
    return close;
}



// WEBPACK FOOTER //
// ./src/components/Confirmation/index.js